import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=195fc852&"
import script from "./NumberInput.vue?vue&type=script&lang=js&"
export * from "./NumberInput.vue?vue&type=script&lang=js&"
import style0 from "./NumberInput.vue?vue&type=style&index=0&id=195fc852&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports